import { Ref, forwardRef } from 'react';
import './style.scss';
import AntdTable from 'antd/es/table';
import { TableProps, TablePaginationConfig } from 'antd/es/table';
import Select from '../select';

function Table<RecordType extends object = any>(props: TableProps<RecordType>, ref: Ref<any>) {
    const pagination = props.pagination
        ? ({
              size: 'default',
              showSizeChanger: true,
              showQuickJumper: true,
              hideOnSinglePage: true,
              selectComponentClass: Select,
              ...props.pagination,
          } as TablePaginationConfig)
        : false;

    // 添加斑马纹 classname
    const rowClassName = (record: any, index: number, indent: number) => {
        const addGrainClass = index % 2 === 0 ? '' : 'grain';

        const rowcls =
            typeof props.rowClassName === 'function'
                ? `${props.rowClassName(record, index, indent)} ${addGrainClass}`
                : typeof props.rowClassName === 'string'
                ? `${props.rowClassName} ${addGrainClass}`
                : `${addGrainClass}`;

        return rowcls;
    };

    return <AntdTable<RecordType> size="small" bordered {...props} pagination={pagination} ref={ref} rowClassName={rowClassName} />;
}

Table.displayName = 'Table';

export default forwardRef(Table);
